<template>
    <div class="show-more--block">
        <collapse-transition>
            <div v-show="isShowMore" class="show-more--block__others-condition">
                <slot name="more-condition-content"></slot>
            </div>
        </collapse-transition>
    </div>
</template>
<script lang="ts">
import collapseTransition from "./animation.vue"
export default {
    name: 'TqExpandCondition',
    components: {
        collapseTransition,
    },
    props: {
        isShowMore: {
            default: false,
            type: Boolean
        }
    },
    methods: {

    }
}
</script>

